"use client";
import { jsx } from "react/jsx-runtime";
import createCache from "@emotion/cache";
import { cache } from "@emotion/css";
import { useServerInsertedHTML } from "next/navigation";
import { createContext, useContext, useState } from "react";
const CacheContext = createContext(cache);
const createRootStyleCache = () => {
  const cache2 = createCache({ key: "css" });
  cache2.compat = true;
  const prevInsert = cache2.insert;
  let inserted = [];
  cache2.insert = (...args) => {
    const serialized = args[1];
    if (cache2.inserted[serialized.name] === void 0) {
      inserted.push(serialized.name);
    }
    return prevInsert(...args);
  };
  const flush = () => {
    const prevInserted = inserted;
    inserted = [];
    return prevInserted;
  };
  return { cache: cache2, flush };
};
function RootStyleRegistry({ children }) {
  const [{ cache: cache2, flush }] = useState(() => createRootStyleCache());
  useServerInsertedHTML(() => {
    const names = flush();
    if (names.length === 0)
      return null;
    let styles = "";
    for (const name of names) {
      styles += cache2.inserted[name];
    }
    return /* @__PURE__ */ jsx(
      "style",
      {
        "data-emotion": `${cache2.key} ${names.join(" ")}`,
        dangerouslySetInnerHTML: {
          __html: styles
        }
      }
    );
  });
  return /* @__PURE__ */ jsx(CacheContext.Provider, { value: cache2, children });
}
function useCache() {
  return useContext(CacheContext);
}
export {
  RootStyleRegistry,
  useCache
};
//# sourceMappingURL=root-style-registry.js.map